module.exports = __webpack_public_path__ + "fe13e4170719c2fc586501e777bde143.ttf";